import { create } from 'zustand';

interface ConfirmOptions {
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
}

interface ConfirmState {
  isOpen: boolean;
  options: ConfirmOptions | undefined;

  actions: {
    openConfirm: (options?: ConfirmOptions) => Promise<boolean>;
    closeConfirm: () => void;
    confirmAction: () => void;
  };
}

export const useConfirmStore = create<ConfirmState>()((set) => {
  let resolver: ((confirmed: boolean) => void) | undefined;

  return {
    isOpen: false,
    options: undefined,

    actions: {
      openConfirm: async (options = {}) =>
        new Promise((resolve) => {
          resolver = resolve;
          set({
            isOpen: true,
            options: {
              title: 'Wirklich löschen?',
              confirmText: 'Löschen',
              cancelText: 'Abbrechen',
              ...options,
            },
          });
        }),
      closeConfirm: () => {
        resolver?.(false);
        resolver = undefined;
        set({ isOpen: false, options: undefined });
      },
      confirmAction: () => {
        resolver?.(true);
        resolver = undefined;
        set({ isOpen: false, options: undefined });
      },
    },
  };
});
